import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left\"><defs><style></style></defs><path d=\"M258.3 537.2l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6L355.9 512l360-281.1c3.9-3 6.1-7.7 6.1-12.6V141c0-6.7-7.7-10.4-12.9-6.3L258.3 486.8c-16.4 12.8-16.4 37.6 0 50.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol